import { render } from "./Popup.vue?vue&type=template&id=6be7b2a8&scoped=true"
import script from "./Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Popup.vue?vue&type=script&setup=true&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=6be7b2a8&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be7b2a8"],['__file',"src/components/Popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6be7b2a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6be7b2a8', __exports__)) {
    console.log('reload')
    api.reload('6be7b2a8', __exports__)
  }
  
  module.hot.accept("./Popup.vue?vue&type=template&id=6be7b2a8&scoped=true", () => {
    console.log('re-render')
    api.rerender('6be7b2a8', render)
  })

}


export default __exports__